import React from 'react'
import Finbitui from '../../../presentationals/Admin/CustomerPages/FinBit.component'
import { getFinBitData, getFinBitDataNew } from '../../../containers/Admin/AdminActionCreator.component'
import Loader from '../../../presentationals/Loader/layerLoader.component'
import { _preFormatDate, _formatDateInDash } from '../../../../utils/validation'
import { APIS } from '../../../../utils/api-factory'
import PopupSuccess from '../../../presentationals/Popup/Successpopup.component'
import PopUp from '../../../presentationals/Popup/ErrorPopUp.component'
import CheckReport from '../../../presentationals/Popup/finbitgeneratepopup'
let paginationNumber = 20;

class FinBit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            finBitData: '',
            tableMinPagination: 0,
            tableMaxPagination: paginationNumber,
            loaderState: false,
            type: 'transactionsDetail',
            viewFalse: true,
            finBitDataNew: '',
            datePickerState: false,
            endDate: _preFormatDate(new Date()),
            startDate: _preFormatDate(new Date()),
            bankData: '',
            popupStatus: '',
            popupStateSuccess: false,
            popupStateSuccess: false,
            selectedFilter: '',
            bankDataFibit: '',
            fraudData: '',
            analysisData: '',
            finbitPopup: true,
            regenerate:''
        }
    }
    getAnalysisData() {
        const { allDetail } = this.props
        fetch(APIS.FINBIT_ANALYSIS_API + allDetail.addressDetailsPOList.userId)
            .then(res => res.json())
            .then(json => {
                this.setState({ analysisData: json })
            })
    }
    getData() {

        this.setState({ loaderState: true,finbitPopup:false })
        const { allDetail } = this.props
        fetch(APIS.GET_ACCOUNT_DETAILS_USER_ID + allDetail.addressDetailsPOList.userId)
            .then(res => res.json())
            .then(json => {

                this.setState({ bankData: json }, () => this.getAnalysisData())
            })

        getFinBitData(allDetail.addressDetailsPOList.userId, 'transactionsDetail',this.state.regenerate, callBack => {
            if (callBack != 'no data' && callBack.responseCode != 0) {
                var x = callBack.transactions
                var y = [...x].reverse();
                this.setState({
                    finBitDataNew: y,
                    finBitData: callBack,
                    viewFalse: true,
                    loaderState: false,
                    bankDataFibit: callBack.bank_account

                })

            }
            else {
                this.setState({ loaderState: false })
            }
            if (this.state.finBitData && this.state.bankData) {
                if (this.state.finBitData.bank_account.accountNo === this.state.bankData.accountNumber) {
                    this.setState({ popupStatus: 'Only Account Number Matched', popupStateSuccess: true })
                }
                if (this.state.finBitData.bank_account.ifsCode === this.state.bankData.ifscCode) {
                    this.setState({ popupStatus: 'Only IFSC Matched', popupStateSuccess: true })
                }
                if (this.state.finBitData.bank_account.accountNo === this.state.bankData.accountNumber && this.state.finBitData.bank_account.ifsCode === this.state.bankData.ifscCode) {
                    this.setState({ popupStatus: 'Acount Details Matched', popupStateSuccess: true })

                }

                if (this.state.finBitData.bank_account.accountNo !== this.state.bankData.accountNumber && this.state.finBitData.bank_account.ifsCode !== this.state.bankData.ifscCode) {
                    this.setState({ popupStatus: 'Account Details Not Matched', popupStateError: true })

                }
            }


        })
    }
    closePopup() {
        this.setState({ popupStateSuccess: false, popupStateError: false })
    }
    searchHandler() {
        const { allDetail } = this.props

        this.setState({ loaderState: true })
        getFinBitDataNew(allDetail.userId, 'bankAccountSummary', this.state.startDate, this.state.endDate,this.state.regenerate, callBack => {
            if (callBack != 'no data') {
                var x = callBack.transactions
                var y = [...x].reverse();
                this.setState({
                    type: 'bankAccountSummary',
                    finBitData: y,
                    viewFalse: true,
                    loaderState: false,

                })
            } else {
                this.setState({ loaderState: false })
            }
        })
    }
    onChangeHandlerDate(e, type) {
        if (type == 'startDate') {
            this.setState({ startDate: _formatDateInDash(e) })
        }
        if (type == 'endDate') {
            this.setState({ endDate: _formatDateInDash(e) })


        }

    }
    phocketTablePagination(data, type) {
        if (type == 'back') {
            if (this.state.tableMinPagination >= paginationNumber) {
                this.setState({
                    tableMinPagination: this.state.tableMinPagination - paginationNumber,
                    tableMaxPagination: this.state.tableMaxPagination - paginationNumber,
                })
            }
        } else if (type == 'forward') {
            if (this.state.tableMaxPagination < data.length) {
                this.setState({
                    tableMaxPagination: this.state.tableMaxPagination + paginationNumber,
                    tableMinPagination: this.state.tableMinPagination + paginationNumber
                })
            }
        }
    }
    typeHandler(data) {
        const { allDetail } = this.props
        this.setState({ tableMinPagination: 0, tableMaxPagination: 20, selectedFilter: '' })
        if (data.target.value == 'transactionsDetail') {
            this.setState({ loaderState: true, datePickerState: false, })

            getFinBitData(allDetail.userId, 'transactionsDetail',this.state.regenerate, callBack => {
                if (callBack != 'no data') {
                    var x = callBack.transactions
                    var y = [...x].reverse();
                    this.setState({
                        finBitDataNew: y,
                        finBitData: callBack,
                        viewFalse: true,
                        type: 'transactionsDetail',
                        loaderState: false,
                    })
                } else {
                    this.setState({ loaderState: false })
                }
            })
        }
        if (data.target.value == 'averageMonthlyBalance') {
            this.setState({ loaderState: true, datePickerState: false })


            getFinBitData(allDetail.userId, 'averageMonthlyBalance',this.state.regenerate, callBack => {
                if (callBack != 'no data') {
                    var x = callBack
                    var y = [...x].reverse();
                    this.setState({
                        loaderState: false,
                        type: 'averageMonthlyBalance',
                        finBitData: y
                    })
                } else {
                    this.setState({ loaderState: false })
                }
            })
        }
        if (data.target.value == 'negativeBalanceTransactions') {
            this.setState({ loaderState: true, datePickerState: false })

            getFinBitData(allDetail.userId, 'negativeBalanceTransactions',this.state.regenerate, callBack => {
                if (callBack != 'no data') {
                    var x = callBack
                    var y = [...x].reverse();
                    this.setState({
                        finBitData: y,
                        viewFalse: true,
                        type: 'negativeBalanceTransactions',
                        loaderState: false,
                    })
                } else {
                    this.setState({ loaderState: false })
                }
            })
        }
        if (data.target.value == 'income') {
            this.setState({ loaderState: true, datePickerState: false })

            getFinBitData(allDetail.userId, 'income',this.state.regenerate, callBack => {

                if (callBack != 'no data') {
                    var x = callBack
                    var y = [...x].reverse();
                    this.setState({
                        finBitDataNew: y,
                        viewFalse: true,
                        type: 'income',
                        loaderState: false,
                    })
                } else {
                    this.setState({ loaderState: false })
                }
            })
        }
        if (data.target.value == 'expenses') {
            this.setState({ loaderState: true, datePickerState: false })

            getFinBitData(allDetail.userId, 'expenses',this.state.regenerate, callBack => {
                if (callBack != 'no data') {
                    var x = callBack
                    var y = [...x].reverse();
                    this.setState({
                        finBitDataNew: y,
                        viewFalse: true,
                        type: 'expenses',
                        loaderState: false,
                    })
                } else {
                    this.setState({ loaderState: false })
                }
            })
        }
        if (data.target.value == 'creditCard') {
            this.setState({ loaderState: true, datePickerState: false })

            getFinBitData(allDetail.userId, 'creditCard',this.state.regenerate, callBack => {
                if (callBack != 'no data') {
                    var x = callBack.monthlyDetails
                    var y = [...x].reverse();
                    this.setState({
                        finBitDataNew: y,
                        viewFalse: true,
                        type: 'creditCard',

                        loaderState: false,

                    })
                } else {
                    this.setState({ loaderState: false })
                }
            })
        }
        if (data.target.value == 'highValueTransactions') {
            this.setState({ loaderState: true, datePickerState: false })

            getFinBitData(allDetail.userId, 'highValueTransactions',this.state.regenerate, callBack => {
                if (callBack != 'no data') {
                    var x = callBack
                    var y = [...x].reverse();
                    this.setState({
                        finBitDataNew: y,
                        viewFalse: true,
                        type: 'highValueTransactions',
                        loaderState: false,
                    })
                } else {
                    this.setState({ loaderState: false })
                }
            })
        }
        if (data.target.value == 'moneyReceived') {
            this.setState({ loaderState: true, datePickerState: false })

            getFinBitData(allDetail.userId, 'moneyReceived',this.state.regenerate, callBack => {
                if (callBack != 'no data') {
                    var x = callBack
                    var y = [...x].reverse();
                    this.setState({
                        finBitDataNew: y,
                        viewFalse: true,
                        type: 'moneyReceived',
                        loaderState: false,
                    })
                } else {
                    this.setState({ loaderState: false })
                }
            })
        }
        if (data.target.value == 'moneyReceivedAnalysis') {
            this.setState({ loaderState: true, datePickerState: false })

            getFinBitData(allDetail.userId, 'moneyReceivedAnalysis', this.state.regenerate,callBack => {
                if (callBack != 'no data') {
                    var x = callBack
                    var y = [...x].reverse();
                    this.setState({
                        finBitData: y,
                        finBitDataNew: y,
                        viewFalse: true,
                        type: 'moneyReceivedAnalysis',
                        loaderState: false,
                    })
                } else {
                    this.setState({ loaderState: false })
                }
            })
        }
        if (data.target.value == 'moneyPaidAnalysis') {
            this.setState({ loaderState: true, datePickerState: false })

            getFinBitData(allDetail.userId, 'moneyPaidAnalysis',this.state.regenerate, callBack => {
                if (callBack != 'no data') {
                    var x = callBack
                    var y = [...x].reverse();
                    this.setState({
                        finBitData: y,
                        finBitDataNew: y,
                        viewFalse: true,
                        type: 'moneyPaidAnalysis',
                        loaderState: false,
                    })
                } else {
                    this.setState({ loaderState: false })
                }
            })
        }
        if (data.target.value == 'penaltyAnalysis') {
            this.setState({ loaderState: true, datePickerState: false })

            getFinBitData(allDetail.userId, 'penaltyAnalysis',this.state.regenerate, callBack => {
                if (callBack != 'no data') {
                    var x = callBack
                    var y = [...x].reverse();
                    this.setState({
                        finBitDataNew: y,
                        finBitDataNew: y,
                        viewFalse: true,
                        type: 'penaltyAnalysis',
                        loaderState: false,
                    })
                } else {
                    this.setState({ loaderState: false })
                }
            })
        }
        if (data.target.value == 'loanRepayment') {
            this.setState({ loaderState: true, datePickerState: false })

            getFinBitData(allDetail.userId, 'loanRepayment',this.state.regenerate, callBack => {
                if (callBack != 'no data') {
                    var x = callBack
                    var y = [...x].reverse();

                    this.setState({
                        finBitDataNew: y,
                        viewFalse: true,
                        type: 'loanRepayment',
                        loaderState: false,
                    })
                } else {
                    this.setState({ loaderState: false })
                }
            })
        }
        if (data.target.value == 'averageUtilizationOcNCc') {
            this.setState({ loaderState: true, datePickerState: false })

            getFinBitData(allDetail.userId, 'averageUtilizationOcNCc',this.state.regenerate, callBack => {
                if (callBack != 'no data') {
                    var x = callBack
                    var y = [...x].reverse();
                    this.setState({
                        finBitData: y,
                        viewFalse: true,
                        type: 'averageUtilizationOcNCc',
                        loaderState: false,
                    })
                } else {
                    this.setState({ loaderState: false })
                }
            })
        }
        if (data.target.value == 'loanReceived') {
            this.setState({ loaderState: true, datePickerState: false })

            getFinBitData(allDetail.userId, 'loanReceived',this.state.regenerate, callBack => {
                if (callBack != 'no data') {
                    var x = callBack
                    var y = [...x].reverse();
                    this.setState({
                        finBitDataNew: y,
                        viewFalse: true,
                        type: 'loanReceived',
                        loaderState: false,
                    })
                } else {
                    this.setState({ loaderState: false })
                }
            })
        }
        if (data.target.value == 'frequentTransaction') {
            this.setState({ loaderState: true, datePickerState: false })

            getFinBitData(allDetail.userId, 'frequentTransaction',this.state.regenerate, callBack => {
                if (callBack != 'no data') {
                    var x = callBack
                    var y = [...x].reverse();
                    this.setState({
                        finBitDataNew: y,
                        viewFalse: true,
                        type: 'frequentTransaction',
                        loaderState: false,
                    })
                } else {
                    this.setState({ loaderState: false })
                }
            })
        }
        if (data.target.value == 'bounceTransactions') {
            this.setState({ loaderState: true, datePickerState: false })

            getFinBitData(allDetail.userId, 'bounceTransactions',this.state.regenerate, callBack => {
                if (callBack != 'no data') {
                    var x = callBack
                    var y = [...x].reverse();
                    this.setState({
                        finBitData: y,
                        viewFalse: true,
                        type: 'bounceTransactions',
                        loaderState: false,
                    })
                } else {
                    this.setState({ loaderState: false })
                }
            })
        }
        if (data.target.value == 'bounceTransactionsByDateRange') {
            this.setState({ loaderState: true, datePickerState: false })

            getFinBitData(allDetail.userId, 'bounceTransactionsByDateRange',this.state.regenerate, callBack => {
                if (callBack != 'no data') {
                    var x = callBack
                    var y = [...x].reverse();
                    this.setState({
                        finBitData: y,
                        viewFalse: true,
                        type: 'bounceTransactionsByDateRange',
                        loaderState: false,
                    })
                } else {
                    this.setState({ loaderState: false })
                }
            })
        }
        if (data.target.value == 'sanctionedAmount') {
            this.setState({ loaderState: true, datePickerState: false })

            getFinBitData(allDetail.userId, 'sanctionedAmount',this.state.regenerate, callBack => {
                if (callBack != 'no data') {
                    var x = callBack
                    var y = [...x].reverse();
                    this.setState({
                        finBitData: y,
                        finBitDataNew: y,
                        viewFalse: true,
                        type: 'sanctionedAmount',
                        loaderState: false,
                    })
                } else {
                    this.setState({ loaderState: false })
                }
            })
        }
        if (data.target.value == 'ecsNNach') {
            this.setState({ loaderState: true, datePickerState: false })

            getFinBitData(allDetail.userId, 'ecsNNach',this.state.regenerate, callBack => {
                if (callBack != 'no data') {
                    var x = callBack
                    var y = [...x].reverse();
                    this.setState({
                        finBitDataNew: y,
                        viewFalse: true,
                        type: 'ecsNNach',
                        loaderState: false,
                    })
                } else {
                    this.setState({ loaderState: false })
                }
            })
        }
        if (data.target.value == 'creditCardPayment') {
            this.setState({ loaderState: true, datePickerState: false })

            getFinBitData(allDetail.userId, 'creditCardPayment',this.state.regenerate, callBack => {
                if (callBack != 'no data') {
                    var x = callBack
                    var y = [...x].reverse();
                    this.setState({
                        finBitDataNew: y,
                        viewFalse: true,
                        type: 'creditCardPayment',
                        loaderState: false,
                    })
                } else {
                    this.setState({ loaderState: false })
                }
            })
        }
        if (data.target.value == 'averageBankBalancePerMonth') {
            this.setState({ loaderState: true, datePickerState: false })

            getFinBitData(allDetail.userId, 'averageBankBalancePerMonth',this.state.regenerate, callBack => {
                if (callBack != 'no data') {
                    var x = callBack
                    var y = [...x].reverse();
                    this.setState({
                        finBitData: y,
                        viewFalse: true,
                        type: 'averageBankBalancePerMonth',
                        loaderState: false,
                    })
                } else {
                    this.setState({ loaderState: false })
                }
            })
        }
        if (data.target.value == 'monthSinceLastBounce') {
            this.setState({ loaderState: true, datePickerState: false })

            getFinBitData(allDetail.userId, 'monthSinceLastBounce',this.state.regenerate, callBack => {
                if (callBack != 'no data') {
                    var x = callBack
                    var y = [...x].reverse();
                    this.setState({
                        finBitData: y,
                        viewFalse: true,
                        type: 'monthSinceLastBounce',
                        loaderState: false,
                    })
                } else {
                    this.setState({ loaderState: false })
                }
            })
        }
        if (data.target.value == 'checkInCompleteBankStatementDateDuration') {
            this.setState({ loaderState: true, datePickerState: false })

            getFinBitData(allDetail.userId, 'checkInCompleteBankStatementDateDuration',this.state.regenerate, callBack => {
                if (callBack != 'no data') {
                    var x = callBack
                    var y = [...x].reverse();
                    this.setState({
                        finBitData: y,
                        viewFalse: true,
                        type: 'checkInCompleteBankStatementDateDuration',
                        loaderState: false,
                    })
                } else {
                    this.setState({ loaderState: false })
                }
            })
        }
        if (data.target.value == 'summaryForSavingAccount') {
            this.setState({ loaderState: true, datePickerState: false })

            getFinBitData(allDetail.userId, 'summaryForSavingAccount',this.state.regenerate, callBack => {
                if (callBack != 'no data') {
                    var x = callBack.transactions
                    var y = [...x].reverse();
                    this.setState({
                        fraudData: callBack,
                        finBitDataNew: y,
                        viewFalse: true,
                        type: 'summaryForSavingAccount',
                        loaderState: false,
                    })
                } else {
                    this.setState({ loaderState: false })
                }
            })
        }
        if (data.target.value == 'bankAccountSummary') {
            this.setState({ loaderState: true, datePickerState: true })


            getFinBitDataNew(allDetail.userId, 'bankAccountSummary', this.state.startDate, this.state.endDate,this.state.regenerate, callBack => {
                if (callBack != 'no data') {
                    var x = callBack
                    var y = [...x].reverse();
                    this.setState({
                        type: 'bankAccountSummary',
                        finBitData: y,
                        viewFalse: true,
                        loaderState: false,
                    })
                } else {
                    this.setState({ loaderState: false })
                }
            })
        }
    }
    finterChangeHandler(e) {
        this.setState({ selectedFilter: e.target.value })
    }
    ConfirmCrifDataGenerate(type) {
        if (type === 'yes') {
            this.setState({ regenerate: 1 }, () => this.getData())
        }
        if (type === 'no') {
            this.setState({ regenerate: 0 }, () => this.getData())
        }

    }
    render() {
        const {admin}=this.props
        let filterData = this.state.finBitDataNew
        if (this.state.selectedFilter && this.state.selectedFilter != '' && filterData != null && filterData != '' && filterData.length > 0) {
            filterData = filterData.filter((row) => {
                if (row.description != null) {
                    return row.description.toLowerCase().includes(this.state.selectedFilter.toLowerCase())
                }
            })
        }
        return (
            <div>
                {this.state.finbitPopup ?
                    <CheckReport admin={admin} ConfirmCrifDataGenerate={this.ConfirmCrifDataGenerate.bind(this)} />
                    : ""}
                {this.state.loaderState ?
                    <Loader />
                    : ""}
                {this.state.popupStateError ?
                    <PopUp
                        popupStatus={this.state.popupStatus}
                        closePopup={this.closePopup.bind(this)} />
                    : ""}
                {this.state.popupStateSuccess ?
                    <PopupSuccess
                        popupStatus={this.state.popupStatus}
                        closePopup={this.closePopup.bind(this)} />
                    : ""}
                {this.state.finbitPopup === false ?
                    <Finbitui
                        analysisData={this.state.analysisData}
                        fraudData={this.state.fraudData}
                        bankDataFibit={this.state.bankDataFibit}
                        finterChangeHandler={this.finterChangeHandler.bind(this)}
                        datePickerState={this.state.datePickerState}
                        searchHandler={this.searchHandler.bind(this)}
                        onChangeHandlerDate={this.onChangeHandlerDate.bind(this)}
                        startDate={this.state.startDate}
                        endDate={this.state.endDate}
                        finBitDataNew={filterData}
                        // finBitDataNew={this.state.finBitDataNew}
                        type={this.state.type}
                        viewFalse={this.state.viewFalse}
                        typeHandler={this.typeHandler.bind(this)}
                        phocketTablePagination={this.phocketTablePagination.bind(this)}
                        tableMinPagination={this.state.tableMinPagination}
                        tableMaxPagination={this.state.tableMaxPagination}
                        finBitData={this.state.finBitData}
                    />
                    : ""}
            </div>
        )
    }
}
export default FinBit